import * as Types from '../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type WholeSyncableInvestigationCatalogueItemFragment = { readonly __typename?: 'SyncableInvestigationCatalogueItem', readonly activityType: string, readonly version: number, readonly id: string, readonly coding?: { readonly __typename?: 'CatalogueCoding', readonly elephant?: { readonly __typename?: 'SpecificationReference', readonly code: string, readonly display?: string | null, readonly system?: string | null } | null, readonly loinc?: { readonly __typename?: 'SpecificationReference', readonly code: string, readonly display?: string | null, readonly system?: string | null } | null } | null, readonly keywords?: ReadonlyArray<{ readonly __typename?: 'I18nString', readonly en: string } | null> | null, readonly result?: { readonly __typename?: 'InvestigationItemResult', readonly resultSchema: unknown } | null, readonly title: { readonly __typename?: 'I18nString', readonly en: string }, readonly meta?: { readonly __typename?: 'SyncableMeta', readonly deleted: boolean, readonly updatedAt: string, readonly createdAt: string, readonly updatedByUserId: string, readonly createdByUserId: string } | null };

export type InvestigationCatalogueItemPullQueryVariables = Types.Exact<{
  input: Types.PullInvestigationCatalogueItemInput;
}>;


export type InvestigationCatalogueItemPullQuery = { readonly __typename?: 'Query', readonly pullInvestigationCatalogueItem: { readonly __typename?: 'PullInvestigationCatalogueResponse', readonly checkpoint?: { readonly __typename?: 'SyncableCheckpoint', readonly id: string, readonly updatedAt: string } | null, readonly documents: ReadonlyArray<{ readonly __typename?: 'SyncableInvestigationCatalogueItem', readonly activityType: string, readonly version: number, readonly id: string, readonly coding?: { readonly __typename?: 'CatalogueCoding', readonly elephant?: { readonly __typename?: 'SpecificationReference', readonly code: string, readonly display?: string | null, readonly system?: string | null } | null, readonly loinc?: { readonly __typename?: 'SpecificationReference', readonly code: string, readonly display?: string | null, readonly system?: string | null } | null } | null, readonly keywords?: ReadonlyArray<{ readonly __typename?: 'I18nString', readonly en: string } | null> | null, readonly result?: { readonly __typename?: 'InvestigationItemResult', readonly resultSchema: unknown } | null, readonly title: { readonly __typename?: 'I18nString', readonly en: string }, readonly meta?: { readonly __typename?: 'SyncableMeta', readonly deleted: boolean, readonly updatedAt: string, readonly createdAt: string, readonly updatedByUserId: string, readonly createdByUserId: string } | null }> } };

export const WholeSyncableInvestigationCatalogueItemFragmentDoc = gql`
    fragment WholeSyncableInvestigationCatalogueItem on SyncableInvestigationCatalogueItem {
  activityType
  coding {
    elephant {
      code
      display
      system
    }
    loinc {
      code
      display
      system
    }
  }
  version
  id
  keywords {
    en
  }
  result {
    resultSchema
  }
  title {
    en
  }
  meta {
    deleted
    updatedAt
    createdAt
    updatedByUserId
    createdByUserId
  }
}
    `;
export const InvestigationCatalogueItemPullDocument = gql`
    query InvestigationCatalogueItemPull($input: PullInvestigationCatalogueItemInput!) {
  pullInvestigationCatalogueItem(input: $input) {
    checkpoint {
      id
      updatedAt
    }
    documents {
      ...WholeSyncableInvestigationCatalogueItem
    }
  }
}
    ${WholeSyncableInvestigationCatalogueItemFragmentDoc}`;

/**
 * __useInvestigationCatalogueItemPullQuery__
 *
 * To run a query within a React component, call `useInvestigationCatalogueItemPullQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvestigationCatalogueItemPullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvestigationCatalogueItemPullQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInvestigationCatalogueItemPullQuery(baseOptions: Apollo.QueryHookOptions<InvestigationCatalogueItemPullQuery, InvestigationCatalogueItemPullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvestigationCatalogueItemPullQuery, InvestigationCatalogueItemPullQueryVariables>(InvestigationCatalogueItemPullDocument, options);
      }
export function useInvestigationCatalogueItemPullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvestigationCatalogueItemPullQuery, InvestigationCatalogueItemPullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvestigationCatalogueItemPullQuery, InvestigationCatalogueItemPullQueryVariables>(InvestigationCatalogueItemPullDocument, options);
        }
export type InvestigationCatalogueItemPullQueryHookResult = ReturnType<typeof useInvestigationCatalogueItemPullQuery>;
export type InvestigationCatalogueItemPullLazyQueryHookResult = ReturnType<typeof useInvestigationCatalogueItemPullLazyQuery>;
export type InvestigationCatalogueItemPullQueryResult = Apollo.QueryResult<InvestigationCatalogueItemPullQuery, InvestigationCatalogueItemPullQueryVariables>;